'use strict';

var React = require('react');

var App = React.createClass({
    render: function() {
        return (
            <div>
                {this.props.children}
                {window.NOA.userContext.isExisting ? <iframe id="checkSession" src={window.NOA.configuration.firstNetCheckSessionUrl} width="0" height="0" style={{ display: 'none' } }></iframe> : ''}
            </div>
		);
	}
});

module.exports = App;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/App.jsx